import { ExpertiseDetail, ExpertiseType } from "@/types/expertise"

export const expertiseDetails: Record<string, ExpertiseDetail> = {
  "ppf-wrap": {
    id: "ppf-wrap",
    title: "Detailing",
    subtitle: "Paint Protection Film",
    description: "Bescherm uw auto's lak met onze premium PPF wrap diensten. Onzichtbare maar effectieve bescherming tegen steenslag, krassen en UV-straling.",
    image: "https://lozejxkhsvwkksgzhrfd.supabase.co/storage/v1/object/public/images/Vermado%20automotive_Website%20fotos%20%2010%20april-25.jpg",
    benefits: [
      "Onzichtbare bescherming die de originele lak volledig behoudt",
      "Bescherming tegen steenslag, krassen en andere schade",
      "UV-bestendig om vergeling en verkleuring te voorkomen",
      "Zelfhelende eigenschappen bij lichte krassen",
      "Verhoogt de restwaarde van uw voertuig aanzienlijk"
    ],
    process: [
      "Grondige reiniging en voorbereiding van het voertuig",
      "Digitaal inmeten en op maat snijden van de PPF",
      "Professionele installatie door gecertificeerde specialisten",
      "Zorgvuldige afwerking van alle randen en hoeken",
      "Kwaliteitscontrole en instructies voor onderhoud"
    ],
    specifications: [
      {
        name: "Duurzaamheid",
        value: "10+ jaar",
        description: "Gegarandeerde bescherming voor meer dan een decennium"
      },
      {
        name: "Dikte",
        value: "200 micron",
        description: "Optimale dikte voor maximale bescherming"
      },
      {
        name: "UV-Bestendig",
        value: "99.9%",
        description: "Voorkomt vergeling en verkleuring"
      },
      {
        name: "Zelfhelend",
        value: "Ja",
        description: "Kleine krassen verdwijnen vanzelf bij warmte"
      }
    ],
    materials: [
      {
        name: "XPEL Ultimate Plus",
        brand: "XPEL",
        description: "Premium zelfhelende PPF film met 10 jaar garantie. Biedt superieure bescherming tegen steenslag en krassen.",
        image: "https://images.unsplash.com/photo-1619927228268-e939f3ba9474?q=80&w=2532&auto=format&fit=crop"
      },
      {
        name: "3M Scotchgard Pro Series",
        brand: "3M",
        description: "Hoogwaardige PPF met uitstekende optische helderheid en duurzame bescherming.",
        image: "https://images.unsplash.com/photo-1619927228268-e939f3ba9474?q=80&w=2532&auto=format&fit=crop"
      }
    ],
    certifications: [
      {
        name: "XPEL Certified Installer",
        issuer: "XPEL Technologies",
        validUntil: "2025-12-31",
        image: "https://images.unsplash.com/photo-1619927228268-e939f3ba9474?q=80&w=2532&auto=format&fit=crop"
      },
      {
        name: "3M Preferred Installer",
        issuer: "3M Automotive",
        validUntil: "2025-12-31",
        image: "https://images.unsplash.com/photo-1619927228268-e939f3ba9474?q=80&w=2532&auto=format&fit=crop"
      }
    ],
    statistics: {
      projectsCompleted: 1500,
      yearsExperience: 10,
      satisfactionRate: 99,
      clientsServed: 1200
    },
    packages: [
      {
        name: "Front Protection",
        price: "€1.499",
        description: "Bescherming voor de meest kwetsbare delen",
        features: [
          "Motorkap",
          "Voorbumper",
          "Koplampen",
          "Spiegels",
          "2 jaar garantie"
        ],
        buttonText: "Selecteer pakket"
      },
      {
        name: "Full Front Protection",
        price: "€2.499",
        description: "Uitgebreide bescherming voor de voorzijde",
        features: [
          "Alles van Front Protection",
          "Volledige voorspatborden",
          "A-stijlen",
          "5 jaar garantie"
        ],
        buttonText: "Selecteer pakket",
        isPopular: true
      },
      {
        name: "Full Vehicle Protection",
        price: "€4.999",
        description: "Complete bescherming voor het hele voertuig",
        features: [
          "Volledige auto",
          "Alle panelen",
          "Alle bumpers",
          "10 jaar garantie"
        ],
        buttonText: "Selecteer pakket"
      }
    ],
    faq: [
      {
        category: "Installatie",
        question: "Hoe lang duurt de installatie?",
        answer: "De installatietijd varieert van 1-3 dagen, afhankelijk van het gekozen pakket."
      },
      {
        category: "Onderhoud",
        question: "Hoe onderhoud ik de PPF wrap?",
        answer: "Regelmatig wassen met pH-neutrale shampoo en vermijd agressieve chemicaliën."
      },
      {
        category: "Garantie",
        question: "Wat houdt de garantie in?",
        answer: "We bieden tot 10 jaar garantie op vergeling, verkleuring en materiaaldefecten."
      },
      {
        category: "Verwijdering",
        question: "Kan de PPF later verwijderd worden?",
        answer: "Ja, de PPF kan professioneel verwijderd worden zonder schade aan de lak."
      }
    ],
    relatedServices: [
      {
        id: "ceramic-coating",
        title: "Ceramic Coating",
        description: "Extra beschermlaag voor nog meer glans en bescherming",
        price: "Vanaf €899",
        image: "https://images.unsplash.com/photo-1619927228268-e939f3ba9474?q=80&w=2532&auto=format&fit=crop"
      },
      {
        id: "detailing",
        title: "Paint Correction",
        description: "Professionele lakbehandeling voor het beste resultaat",
        price: "Vanaf €599",
        image: "https://images.unsplash.com/photo-1619927228268-e939f3ba9474?q=80&w=2532&auto=format&fit=crop"
      }
    ],
    guarantee: {
      duration: "Tot 10 jaar garantie",
      coverage: [
        "Vergeling",
        "Verkleuring",
        "Materiaaldefecten",
        "Installatie gebreken"
      ],
      terms: [
        "Jaarlijkse inspectie vereist",
        "Gebruik van goedgekeurde reinigingsproducten",
        "Schade door ongevallen uitgesloten"
      ]
    },
    qualityStandards: [
      {
        icon: "🔍",
        name: "Precisie Installatie",
        description: "Computergestuurde snijpatronen voor perfecte pasvorm"
      },
      {
        icon: "🧹",
        name: "Stofvrije Omgeving",
        description: "Installatie in een geconditioneerde, stofvrije ruimte"
      },
      {
        icon: "👨‍🔧",
        name: "Gecertificeerde Installateurs",
        description: "Alle technici zijn XPEL en 3M gecertificeerd"
      }
    ],
    maintenanceTips: [
      {
        title: "Regelmatig Wassen",
        description: "Was de auto elke 2 weken met pH-neutrale autoshampoo",
        importance: "high",
        frequency: "Elke 2 weken"
      },
      {
        title: "Inspectie",
        description: "Laat de PPF jaarlijks inspecteren voor optimale bescherming",
        importance: "medium",
        frequency: "Jaarlijks"
      },
      {
        title: "Vlekbehandeling",
        description: "Behandel hardnekkige vlekken direct met speciale PPF reiniger",
        importance: "low",
        frequency: "Indien nodig"
      }
    ]
  },
  "chiptuning": {
    id: "chiptuning",
    title: "CHIPTUNING",
    subtitle: "Performance Optimization",
    description: "Bij Vermado Automotive zijn wij specialisten in het optimaliseren van de prestaties van uw voertuig door middel van professionele chiptuning. Onze geavanceerde tuning software en expertise zorgen ervoor dat uw motor efficiënter werkt, meer vermogen levert en een betere respons biedt. Wij stemmen de motormanagementsystemen perfect af op uw specifieke wensen en rijstijl, zonder de betrouwbaarheid te compromitteren.",
    image: "https://lozejxkhsvwkksgzhrfd.supabase.co/storage/v1/object/public/images/chiptuning%20(1).jpg",
    benefits: [
      "Tot 30% meer vermogen en koppel",
      "Verbeterde acceleratie en reactievermogen",
      "Efficiënter brandstofverbruik bij gelijkblijvende rijstijl",
      "Behoud van fabrieksbetrouwbaarheid",
      "Volledig reversibel zonder blijvende aanpassingen"
    ],
    process: [
      "Uitgebreide diagnostische scan van uw voertuig",
      "Backup maken van de originele software",
      "Professionele aanpassing van motorsturing op basis van uw wensen",
      "Testen en finetunen voor optimale prestaties",
      "Uitvoeren van een voor- en nameting"
    ],
    materials: [
      {
        name: "EVC Flasher Pro",
        brand: "EVC Tuning",
        description: "Professionele tuning hardware voor optimale prestaties en veiligheid",
        image: "https://images.unsplash.com/photo-1511919884226-fd3cad34687c?q=80&w=3432&auto=format&fit=crop"
      },
      {
        name: "Quantum Tuning Box",
        brand: "Quantum",
        description: "Geavanceerde plug & play tuning oplossing voor maximale flexibiliteit",
        image: "https://images.unsplash.com/photo-1503376780353-7e6692767b70?q=80&w=3432&auto=format&fit=crop"
      }
    ],
    certifications: [
      {
        name: "Master Tuner Certification",
        issuer: "EVC Academy",
        validUntil: "2025-12-31",
        image: "https://images.unsplash.com/photo-1568605117036-5fe5e7bab0b7?q=80&w=3432&auto=format&fit=crop"
      }
    ],
    statistics: {
      projectsCompleted: 2500,
      yearsExperience: 15,
      satisfactionRate: 98,
      clientsServed: 2000
    },
    packages: [
      {
        name: "Stage 1 Tuning",
        price: "€499",
        description: "Basis optimalisatie voor dagelijks gebruik",
        features: [
          "10-15% meer vermogen",
          "15-20% meer koppel",
          "Brandstofbesparing",
          "2 jaar garantie"
        ],
        buttonText: "Selecteer pakket"
      },
      {
        name: "Stage 2 Tuning",
        price: "€799",
        description: "Gevorderde tuning voor maximale prestaties",
        features: [
          "20-25% meer vermogen",
          "25-30% meer koppel",
          "Sport uitlaat mapping",
          "3 jaar garantie"
        ],
        buttonText: "Selecteer pakket",
        isPopular: true
      },
      {
        name: "Stage 3 Tuning",
        price: "€1.299",
        description: "Ultimate performance package",
        features: [
          "25-30% meer vermogen",
          "30-35% meer koppel",
          "Custom mapping",
          "5 jaar garantie"
        ],
        buttonText: "Selecteer pakket"
      }
    ],
    faq: [
      {
        category: "Prestaties",
        question: "Is chiptuning veilig voor mijn motor?",
        answer: "Ja, onze professionele tuning respecteert alle veiligheidsmarges van de fabrikant."
      },
      {
        category: "Garantie",
        question: "Wat gebeurt er met mijn fabrieksgarantie?",
        answer: "We bieden een eigen garantie en kunnen de originele mapping altijd terugzetten."
      },
      {
        category: "Technisch",
        question: "Hoe lang duurt een chiptuning?",
        answer: "Gemiddeld 2-3 uur, afhankelijk van het type voertuig en gekozen package."
      },
      {
        category: "Onderhoud",
        question: "Zijn er speciale onderhoudseisen?",
        answer: "Regulier onderhoud volstaat, wel adviseren we hoogwaardige brandstof te gebruiken."
      }
    ],
    relatedServices: [
      {
        id: "uitlaat",
        title: "Sport Uitlaat",
        description: "Verbeter het geluid en de prestaties",
        price: "Vanaf €799",
        image: "https://images.unsplash.com/photo-1492144534655-ae79c964c9d7?q=80&w=2583&auto=format&fit=crop"
      },
      {
        id: "dyno",
        title: "Dyno Testing",
        description: "Exacte vermogensmeting voor en na",
        price: "Vanaf €149",
        image: "https://images.unsplash.com/photo-1492144534655-ae79c964c9d7?q=80&w=2583&auto=format&fit=crop"
      }
    ],
    guarantee: {
      duration: "Tot 5 jaar garantie",
      coverage: [
        "ECU Hardware",
        "Software mapping",
        "Motorprestaties",
        "Brandstofverbruik"
      ],
      terms: [
        "Regulier onderhoud vereist",
        "Gebruik van voorgeschreven brandstof",
        "Geen race gebruik"
      ]
    },
    qualityStandards: [
      {
        icon: "🔧",
        name: "OBD Diagnose",
        description: "Uitgebreide diagnose voor optimale afstemming"
      },
      {
        icon: "📊",
        name: "Dyno Tested",
        description: "Elke mapping wordt getest op de vermogenstestbank"
      },
      {
        icon: "💻",
        name: "Custom Software",
        description: "Speciaal ontwikkelde software voor elk type motor"
      }
    ],
    maintenanceTips: [
      {
        title: "Brandstof Kwaliteit",
        description: "Gebruik hoogwaardige brandstof voor optimale prestaties",
        importance: "high",
        frequency: "Bij elke tankbeurt"
      },
      {
        title: "Olie Verversen",
        description: "Ververs de olie volgens schema met hoogwaardige motorolie",
        importance: "medium",
        frequency: "Volgens onderhoudsschema"
      },
      {
        title: "Performance Check",
        description: "Laat de tuning periodiek controleren voor optimale werking",
        importance: "low",
        frequency: "Jaarlijks"
      }
    ]
  },
  "modificaties": {
    id: "modificaties",
    title: "MODIFICATIES",
    subtitle: "Custom Upgrades",
    description: "Van uitlaat upgrades tot complete carrosserie modificaties voor uw auto.",
    image: "https://images.unsplash.com/photo-1544829099-b9a0c07fad1a?q=80&w=3432&auto=format&fit=crop",
    benefits: [
      "Gepersonaliseerde look die uw voertuig onderscheidt",
      "Verbeterde prestaties afgestemd op uw rijstijl",
      "Waardevermeerdering bij geselecteerde upgrades",
      "Combinatie van esthetiek en functionaliteit",
      "Behoud van betrouwbaarheid en dagelijks gebruiksgemak"
    ],
    process: [
      "Persoonlijk gesprek over uw wensen en doelstellingen",
      "Gedetailleerd voorstel met 3D-visualisaties",
      "Zorgvuldige selectie van hoogwaardige componenten",
      "Vakkundige installatie met minimale impact",
      "Fijnafstelling en kwaliteitscontrole"
    ],
    materials: [
      {
        name: "Performance Uitlaat",
        brand: "Akrapovič",
        description: "Premium uitlaatsystemen voor optimaal geluid en prestaties",
        image: "https://images.unsplash.com/photo-1626668893632-6f3a4466d22f?q=80&w=3432&auto=format&fit=crop"
      },
      {
        name: "Coilover Kit",
        brand: "KW Suspensions",
        description: "Hoogwaardige verstelbare onderstellen voor perfecte wegligging",
        image: "https://images.unsplash.com/photo-1537984822441-cff330075342?q=80&w=3432&auto=format&fit=crop"
      }
    ],
    certifications: [
      {
        name: "TÜV Certified",
        issuer: "TÜV Süd",
        validUntil: "2025-12-31",
        image: "https://images.unsplash.com/photo-1626668893632-6f3a4466d22f?q=80&w=3432&auto=format&fit=crop"
      },
      {
        name: "KW Certified Installer",
        issuer: "KW Automotive",
        validUntil: "2025-12-31",
        image: "https://images.unsplash.com/photo-1626668893632-6f3a4466d22f?q=80&w=3432&auto=format&fit=crop"
      }
    ],
    statistics: {
      projectsCompleted: 3000,
      yearsExperience: 15,
      satisfactionRate: 98,
      clientsServed: 2500
    },
    packages: [
      {
        name: "Styling Package",
        price: "€2.499",
        description: "Basis styling modificaties",
        features: [
          "Verlaging",
          "Sportvelgen",
          "Spoiler kit",
          "2 jaar garantie"
        ],
        buttonText: "Selecteer pakket"
      },
      {
        name: "Performance Package",
        price: "€4.999",
        description: "Complete performance upgrade",
        features: [
          "KW Schroefset",
          "Sport uitlaat",
          "Remmen upgrade",
          "3 jaar garantie"
        ],
        buttonText: "Selecteer pakket",
        isPopular: true
      },
      {
        name: "Ultimate Package",
        price: "€7.999",
        description: "Maximale prestaties en styling",
        features: [
          "Alles van Performance",
          "Custom bodykit",
          "BBS Velgen",
          "5 jaar garantie"
        ],
        buttonText: "Selecteer pakket"
      }
    ],
    faq: [
      {
        category: "Technisch",
        question: "Zijn de modificaties legaal?",
        answer: "Ja, alle modificaties zijn TÜV gecertificeerd en voldoen aan de RDW eisen."
      },
      {
        category: "Garantie",
        question: "Wat gebeurt er met mijn fabrieksgarantie?",
        answer: "We bespreken dit vooraf en bieden een eigen garantie op onze modificaties."
      },
      {
        category: "Installatie",
        question: "Hoe lang duurt een modificatie?",
        answer: "Dit varieert van 1-5 dagen, afhankelijk van de complexiteit."
      },
      {
        category: "Onderhoud",
        question: "Is er speciaal onderhoud nodig?",
        answer: "We geven specifieke onderhoudsinstructies bij elke modificatie."
      }
    ],
    relatedServices: [
      {
        id: "chiptuning",
        title: "Chiptuning",
        description: "Optimaliseer de prestaties van uw motor",
        price: "Vanaf €499",
        image: "https://images.unsplash.com/photo-1626668893632-6f3a4466d22f?q=80&w=3432&auto=format&fit=crop"
      },
      {
        id: "wrappen",
        title: "Car Wrapping",
        description: "Perfecte afwerking voor uw modificaties",
        price: "Vanaf €2.999",
        image: "https://images.unsplash.com/photo-1626668893632-6f3a4466d22f?q=80&w=3432&auto=format&fit=crop"
      }
    ],
    guarantee: {
      duration: "Tot 5 jaar garantie",
      coverage: [
        "Onderdelen",
        "Installatie",
        "Afwerking",
        "Performance"
      ],
      terms: [
        "Regulier onderhoud vereist",
        "Geen race gebruik",
        "Jaarlijkse inspectie aanbevolen"
      ]
    },
    qualityStandards: [
      {
        icon: "🔧",
        name: "TÜV Certificering",
        description: "Alle modificaties zijn TÜV gecertificeerd"
      },
      {
        icon: "🏁",
        name: "Race Expertise",
        description: "Kennis uit motorsport toegepast op straatauto's"
      },
      {
        icon: "📊",
        name: "Dyno Tested",
        description: "Performance modificaties getest op vermogenstestbank"
      }
    ],
    maintenanceTips: [
      {
        title: "Regelmatige Inspectie",
        description: "Laat modificaties elke 10.000 km controleren",
        importance: "high",
        frequency: "Elke 10.000 km"
      },
      {
        title: "Schroefset Controle",
        description: "Check de schroefset op speling en corrosie",
        importance: "medium",
        frequency: "Halfjaarlijks"
      },
      {
        title: "Velgen Balanceren",
        description: "Laat de velgen regelmatig balanceren",
        importance: "low",
        frequency: "Jaarlijks"
      }
    ]
  },
  "tuning-kits": {
    id: "tuning-kits",
    title: "TUNING KITS",
    subtitle: "Complete Pakketten",
    description: "Complete tuning oplossingen voor optimale prestaties en betrouwbaarheid.",
    image: "https://images.unsplash.com/photo-1607603750909-408e193868c7?q=80&w=3432&auto=format&fit=crop",
    benefits: [
      "Gebalanceerde aanpak voor optimale prestatieverbetering",
      "Uitgebreide garantie op alle onderdelen en installatie",
      "Compatibiliteit tussen alle componenten gegarandeerd",
      "Vaak geleverd met ondersteunende software-upgrades",
      "TÜV-certificering mogelijk voor wettelijke goedkeuring"
    ],
    process: [
      "Evaluatie van de huidige staat van uw voertuig",
      "Afstemming van het pakket op uw specifieke model en wensen",
      "Gecertificeerde installatie van alle componenten",
      "Uitgebreide tests op een rollenbank voor optimalisatie",
      "Aflevering met gedetailleerde documentatie en instructies"
    ],
    materials: [
      {
        name: "Stage 1 Kit",
        brand: "Vermado",
        description: "Complete tuning kit voor optimale prestaties",
        image: "https://images.unsplash.com/photo-1562519819-016930ada31b?q=80&w=3432&auto=format&fit=crop"
      },
      {
        name: "Stage 2 Kit",
        brand: "Vermado",
        description: "Geavanceerde tuning kit met hardware upgrades",
        image: "https://images.unsplash.com/photo-1580273916550-e323be2ae537?q=80&w=3432&auto=format&fit=crop"
      }
    ],
    certifications: [
      {
        name: "TÜV Performance",
        issuer: "TÜV Süd",
        validUntil: "2025-12-31",
        image: "https://images.unsplash.com/photo-1562141960-c9a3091f78fb?q=80&w=2940&auto=format&fit=crop"
      },
      {
        name: "ISO 9001:2015",
        issuer: "Quality Institute",
        validUntil: "2025-12-31",
        image: "https://images.unsplash.com/photo-1487754180451-c456f719a1fc?q=80&w=2940&auto=format&fit=crop"
      }
    ],
    statistics: {
      projectsCompleted: 850,
      yearsExperience: 10,
      satisfactionRate: 98,
      clientsServed: 750
    },
    packages: [
      {
        name: "Stage 1 Kit",
        price: "vanaf €1.495",
        description: "Basis performance upgrade kit",
        features: [
          "High-flow luchtfilter",
          "Performance chip",
          "Sportuitlaat einddemper",
          "Installatie"
        ],
        buttonText: "Selecteer Stage 1 Kit"
      },
      {
        name: "Stage 2 Kit",
        price: "vanaf €2.995",
        description: "Geavanceerde performance kit",
        features: [
          "Stage 1 +",
          "Intercooler upgrade",
          "Downpipe",
          "Custom mapping"
        ],
        isPopular: true,
        buttonText: "Selecteer Stage 2 Kit"
      },
      {
        name: "Stage 3 Kit",
        price: "vanaf €4.995",
        description: "Ultimate performance kit",
        features: [
          "Stage 2 +",
          "Turbo upgrade",
          "Brandstof systeem",
          "Race mapping"
        ],
        buttonText: "Selecteer Stage 3 Kit"
      }
    ],
    faq: [
      {
        question: "Zijn de kits plug & play?",
        answer: "De meeste componenten zijn plug & play, maar professionele installatie wordt aanbevolen voor optimale prestaties.",
        category: "Installatie"
      },
      {
        question: "Wat is inbegrepen in de prijs?",
        answer: "De prijs is inclusief alle componenten, professionele installatie, mapping en een basis garantie pakket.",
        category: "Prijzen"
      },
      {
        question: "Kan ik later upgraden?",
        answer: "Ja, onze kits zijn modulair opgezet en kunnen later worden uitgebreid naar een hoger stage.",
        category: "Upgrades"
      },
      {
        question: "Hoe zit het met de garantie?",
        answer: "We bieden 2 jaar garantie op alle componenten en de installatie bij normaal gebruik.",
        category: "Garantie"
      }
    ],
    relatedServices: [
      {
        id: "chiptuning",
        title: "Chiptuning",
        description: "Optimaliseer de prestaties van uw tuning kit",
        image: "https://images.unsplash.com/photo-1492144534655-ae79c964c9d7?q=80&w=2940&auto=format&fit=crop",
        price: "vanaf €495"
      },
      {
        id: "onderhoud",
        title: "Performance Onderhoud",
        description: "Specialistisch onderhoud voor getunede voertuigen",
        image: "https://images.unsplash.com/photo-1486262715619-67b85e0b08d3?q=80&w=2940&auto=format&fit=crop",
        price: "vanaf €295"
      }
    ],
    guarantee: {
      duration: "2 jaar",
      coverage: [
        "Alle componenten",
        "Installatie",
        "Mapping",
        "Performance resultaten"
      ],
      terms: [
        "Registratie binnen 14 dagen",
        "Regulier onderhoud verplicht",
        "Geen race gebruik",
        "Jaarlijkse controle aanbevolen"
      ]
    },
    qualityStandards: [
      {
        name: "TÜV Approved",
        description: "Alle kits voldoen aan TÜV normen",
        icon: "certified"
      },
      {
        name: "OEM+ Kwaliteit",
        description: "Premium componenten van topfabrikanten",
        icon: "quality"
      },
      {
        name: "Expert Installatie",
        description: "Montage door gecertificeerde technici",
        icon: "tools"
      }
    ],
    maintenanceTips: [
      {
        title: "Performance Check",
        description: "Regelmatige controle van alle componenten",
        frequency: "10.000 km",
        importance: "high"
      },
      {
        title: "Mapping Update",
        description: "Optimalisatie van de mapping indien nodig",
        frequency: "12 maanden",
        importance: "medium"
      },
      {
        title: "Filterwissels",
        description: "Tijdig vervangen van performance filters",
        frequency: "15.000 km",
        importance: "high"
      }
    ]
  },
  "wrapping": {
    id: "wrapping",
    type: "WRAPPING" as ExpertiseType,
    title: "WRAPPING",
    subtitle: "Premium Car Wrapping",
    description: "Transformeer uw auto met onze hoogwaardige wrap oplossingen. Van complete kleurveranderingen tot beschermende folies.",
    image: "https://lozejxkhsvwkksgzhrfd.supabase.co/storage/v1/object/public/images//wrappen.jpg",
    benefits: [
      "Bescherming van de originele lak",
      "Eindeloze kleurmogelijkheden",
      "Snelle en professionele uitvoering",
      "Hoogwaardige materialen",
      "Langdurige bescherming"
    ],
    process: [
      "Gratis intake gesprek",
      "Uitgebreide reiniging",
      "Precisie plaatsing",
      "Kwaliteitscontrole",
      "Onderhoudsadvies"
    ],
    materials: [
      {
        name: "Premium Wrap Folie",
        brand: "3M",
        description: "Hoogwaardige wrap folie met uitstekende kleurvastheid",
        image: "https://lozejxkhsvwkksgzhrfd.supabase.co/storage/v1/object/public/images//3m-wrap.webp"
      }
    ],
    certifications: [
      {
        name: "3M Preferred Installer",
        issuer: "3M Automotive",
        validUntil: "2025-12-31",
        image: "https://images.unsplash.com/photo-1611566026373-c6c8da0ea861?q=80&w=2574&auto=format&fit=crop"
      },
      {
        name: "Avery Dennison Certified",
        issuer: "Avery Dennison",
        validUntil: "2025-12-31",
        image: "https://images.unsplash.com/photo-1611566026373-c6c8da0ea861?q=80&w=2574&auto=format&fit=crop"
      }
    ],
    statistics: {
      projectsCompleted: 2000,
      yearsExperience: 12,
      satisfactionRate: 99,
      clientsServed: 1800
    },
    packages: [
      {
        name: "Partial Wrap",
        price: "€1.499",
        description: "Wrap specifieke delen van uw auto",
        features: [
          "Dak en spiegels",
          "Motorkap",
          "Spoilers",
          "2 jaar garantie"
        ],
        buttonText: "Selecteer pakket"
      },
      {
        name: "Full Wrap",
        price: "€2.999",
        description: "Complete auto wrapping",
        features: [
          "Volledige carrosserie",
          "Spiegels en handgrepen",
          "Bumpers",
          "5 jaar garantie"
        ],
        buttonText: "Selecteer pakket",
        isPopular: true
      },
      {
        name: "Luxury Wrap",
        price: "€4.499",
        description: "Premium wrap met speciale effecten",
        features: [
          "Chrome of color-shift",
          "Extra beschermlaag",
          "Keramische coating",
          "7 jaar garantie"
        ],
        buttonText: "Selecteer pakket"
      }
    ],
    faq: [
      {
        category: "Duurzaamheid",
        question: "Hoe lang gaat een car wrap mee?",
        answer: "Bij goed onderhoud gaat een car wrap 5-7 jaar mee zonder kwaliteitsverlies."
      },
      {
        category: "Onderhoud",
        question: "Hoe was ik mijn gewrapte auto?",
        answer: "Handwas met pH-neutrale shampoo, vermijd hogedrukreinigers bij naden."
      },
      {
        category: "Installatie",
        question: "Kan de wrap later verwijderd worden?",
        answer: "Ja, een professioneel aangebrachte wrap kan verwijderd worden zonder lakschade."
      },
      {
        category: "Garantie",
        question: "Wat dekt de garantie?",
        answer: "De garantie dekt verkleuring, loskomen en materiaaldefecten bij normaal gebruik."
      }
    ],
    relatedServices: [
      {
        id: "ppf-wrap",
        title: "PPF Protection",
        description: "Extra bescherming voor uw wrap",
        price: "Vanaf €999",
        image: "https://images.unsplash.com/photo-1611566026373-c6c8da0ea861?q=80&w=2574&auto=format&fit=crop"
      },
      {
        id: "detailing",
        title: "Paint Correction",
        description: "Perfecte ondergrond voor uw wrap",
        price: "Vanaf €599",
        image: "https://images.unsplash.com/photo-1611566026373-c6c8da0ea861?q=80&w=2574&auto=format&fit=crop"
      }
    ],
    guarantee: {
      duration: "Tot 7 jaar garantie",
      coverage: [
        "Verkleuring",
        "Loskomen",
        "Materiaaldefecten",
        "Installatiefouten"
      ],
      terms: [
        "Jaarlijkse inspectie aanbevolen",
        "Gebruik van goedgekeurde reinigingsmiddelen",
        "Geen hogedrukreiniging"
      ]
    },
    qualityStandards: [
      {
        icon: "🔍",
        name: "Lak Inspectie",
        description: "Grondige inspectie en voorbereiding van de lak"
      },
      {
        icon: "🧹",
        name: "Stofvrije Ruimte",
        description: "Installatie in een geconditioneerde, stofvrije ruimte"
      },
      {
        icon: "👨‍🔧",
        name: "Certified Installers",
        description: "Installatie door 3M en Avery gecertificeerde professionals"
      }
    ],
    maintenanceTips: [
      {
        title: "Regelmatig Wassen",
        description: "Was de auto elke 2 weken met speciale wrap shampoo",
        importance: "high",
        frequency: "Elke 2 weken"
      },
      {
        title: "Vlekken Behandeling",
        description: "Verwijder vogelpoep en andere agressieve stoffen direct",
        importance: "medium",
        frequency: "Indien nodig"
      },
      {
        title: "Inspectie",
        description: "Laat de wrap jaarlijks inspecteren op beschadigingen",
        importance: "low",
        frequency: "Jaarlijks"
      }
    ]
  },
  "glascoating": {
    id: "glascoating",
    title: "GLASCOATING",
    subtitle: "Lakbescherming",
    description: "Langdurige bescherming en glans voor uw voertuig met onze premium ceramic coating. Superieure bescherming tegen vervuiling, UV-straling en lichte krassen.",
    image: "https://images.unsplash.com/photo-1507136566006-cfc505b114fc?q=80&w=2940&auto=format&fit=crop",
    benefits: [
      "Langdurige bescherming tot 5 jaar",
      "Extreme waterafstoting en zelfreinigend effect",
      "Intense glans en diepte in de lak",
      "Bescherming tegen chemische vervuiling en UV-straling",
      "Eenvoudiger wassen en onderhoud"
    ],
    process: [
      "Uitgebreide wasbeurt en klei-behandeling",
      "Lakcorrectie en polijsten voor optimale ondergrond",
      "Ontvetting en voorbereiden van de lak",
      "Applicatie van meerdere lagen coating",
      "Uithardingstijd en eindcontrole"
    ],
    specifications: [
      {
        name: "Duurzaamheid",
        value: "5+ jaar",
        description: "Langdurige bescherming gegarandeerd"
      },
      {
        name: "Hardheid",
        value: "9H",
        description: "Maximale krasbestendigheid"
      },
      {
        name: "Glans",
        value: "100%",
        description: "Diepe, spiegelende glans"
      },
      {
        name: "Hydrofobisch",
        value: "120°",
        description: "Extreme waterafstoting"
      }
    ],
    materials: [
      {
        name: "Gtechniq Crystal Serum Ultra",
        brand: "Gtechniq",
        description: "Premium keramische coating met 9H hardheid en extreme duurzaamheid",
        image: "https://images.unsplash.com/photo-1507136566006-cfc505b114fc?q=80&w=2574&auto=format&fit=crop"
      },
      {
        name: "Gyeon Q² Pure",
        brand: "Gyeon",
        description: "Professionele coating met uitstekende hydrofobische eigenschappen",
        image: "https://images.unsplash.com/photo-1507136566006-cfc505b114fc?q=80&w=2574&auto=format&fit=crop"
      }
    ],
    certifications: [
      {
        name: "Gtechniq Accredited",
        issuer: "Gtechniq",
        validUntil: "2025-12-31",
        image: "https://images.unsplash.com/photo-1507136566006-cfc505b114fc?q=80&w=2574&auto=format&fit=crop"
      },
      {
        name: "Gyeon Certified",
        issuer: "Gyeon",
        validUntil: "2025-12-31",
        image: "https://images.unsplash.com/photo-1507136566006-cfc505b114fc?q=80&w=2574&auto=format&fit=crop"
      }
    ],
    statistics: {
      projectsCompleted: 3500,
      yearsExperience: 8,
      satisfactionRate: 99,
      clientsServed: 3000
    },
    packages: [
      {
        name: "Basic Coating",
        price: "€699",
        description: "Basis keramische coating",
        features: [
          "1 laag coating",
          "2 jaar bescherming",
          "Basis voorbereiding",
          "Waterafstotend"
        ],
        buttonText: "Selecteer pakket"
      },
      {
        name: "Pro Coating",
        price: "€999",
        description: "Professionele coating behandeling",
        features: [
          "2 lagen coating",
          "5 jaar bescherming",
          "Paint correction",
          "Extra glans"
        ],
        buttonText: "Selecteer pakket",
        isPopular: true
      },
      {
        name: "Ultra Coating",
        price: "€1.499",
        description: "Ultimate coating protection",
        features: [
          "3 lagen coating",
          "7 jaar bescherming",
          "Full paint correction",
          "Maximale glans"
        ],
        buttonText: "Selecteer pakket"
      }
    ],
    faq: [
      {
        category: "Duurzaamheid",
        question: "Hoe lang gaat de coating mee?",
        answer: "Bij goed onderhoud 5-7 jaar, afhankelijk van het gekozen pakket."
      },
      {
        category: "Onderhoud",
        question: "Hoe was ik mijn gecoate auto?",
        answer: "Gebruik pH neutrale shampoo en vermijd agressieve chemicaliën."
      },
      {
        category: "Proces",
        question: "Hoe lang duurt de behandeling?",
        answer: "2-3 dagen, inclusief lakvoorbereiding en uitharding."
      },
      {
        category: "Bescherming",
        question: "Waartegen beschermt de coating?",
        answer: "Tegen UV, oxidatie, vogelpoep, waterplekken en lichte krassen."
      }
    ],
    relatedServices: [
      {
        id: "detailing",
        title: "Paint Correction",
        description: "Perfecte lakvoorbereiding voor coating",
        price: "Vanaf €299",
        image: "https://images.unsplash.com/photo-1507136566006-cfc505b114fc?q=80&w=2574&auto=format&fit=crop"
      },
      {
        id: "ppf-wrap",
        title: "PPF Protection",
        description: "Extra bescherming voor high-impact zones",
        price: "Vanaf €1.499",
        image: "https://images.unsplash.com/photo-1507136566006-cfc505b114fc?q=80&w=2574&auto=format&fit=crop"
      }
    ],
    guarantee: {
      duration: "Tot 7 jaar garantie",
      coverage: [
        "Glans",
        "Waterafstoting",
        "UV-bescherming",
        "Oxidatie"
      ],
      terms: [
        "Jaarlijkse inspectie",
        "Gebruik aanbevolen producten",
        "Volgens wasvoorschriften"
      ]
    },
    qualityStandards: [
      {
        icon: "🔍",
        name: "Lak Inspectie",
        description: "Gedetailleerde inspectie voor applicatie"
      },
      {
        icon: "🧪",
        name: "Lab Tested",
        description: "Coating getest op duurzaamheid"
      },
      {
        icon: "👨‍🔬",
        name: "Certified Applicator",
        description: "Applicatie door gecertificeerde specialisten"
      }
    ],
    maintenanceTips: [
      {
        title: "Wassen",
        description: "Gebruik alleen pH neutrale autoshampoo",
        importance: "high",
        frequency: "2-3 weken"
      },
      {
        title: "Inspectie",
        description: "Laat de coating jaarlijks inspecteren",
        importance: "medium",
        frequency: "Jaarlijks"
      },
      {
        title: "Topping",
        description: "Gebruik coating booster voor extra glans",
        importance: "low",
        frequency: "Elk kwartaal"
      }
    ]
  },
  "detailing": {
    id: "detailing",
    type: "DETAILING" as ExpertiseType,
    title: "DETAILING",
    subtitle: "Professional Car Detailing",
    description: "Breng uw auto terug naar showroom conditie met onze premium detailing diensten. Van basis reiniging tot complete paint correction.",
    image: "https://lozejxkhsvwkksgzhrfd.supabase.co/storage/v1/object/public/images/Vermado%20automotive_Website%20fotos%20%2010%20april-25.jpg",
    specifications: [
      {
        name: "Behandeling",
        value: "Complete",
        description: "Van binnen en buiten"
      },
      {
        name: "Duur",
        value: "4-8 uur",
        description: "Afhankelijk van pakket"
      },
      {
        name: "Garantie",
        value: "5 jaar",
        description: "Op coating"
      }
    ],
    statistics: {
      projectsCompleted: 2000,
      yearsExperience: 10,
      satisfactionRate: 99,
      clientsServed: 1800
    },
    faq: [
      {
        question: "Hoe vaak moet ik mijn auto laten detaillen?",
        answer: "Dit hangt af van het gebruik en de omstandigheden. Voor dagelijks gebruik adviseren we minimaal 2x per jaar een complete detailing.",
        category: "Onderhoud"
      },
      {
        question: "Hoe lang duurt een complete detailing?",
        answer: "Een complete detailing kan 4-8 uur duren, afhankelijk van de staat van de auto en het gekozen pakket.",
        category: "Tijd"
      }
    ],
    process: [
      "Uitgebreide inspectie",
      "Voorbehandeling en ontvetting",
      "Clay bar behandeling",
      "Polijsten en paint correction",
      "Coating aanbrengen",
      "Interieur reiniging",
      "Finale inspectie"
    ],
    benefits: [
      "Bescherming tegen weersinvloeden",
      "Verbeterde glans en diepte",
      "Makkelijkere reiniging",
      "Waardebehoud van uw auto"
    ],
    materials: [
      {
        name: "Gtechniq Crystal Serum Ultra",
        brand: "Gtechniq",
        description: "Premium keramische coating met 9H hardheid",
        image: "https://images.unsplash.com/photo-1507136566006-cfc505b114fc?q=80&w=2574&auto=format&fit=crop"
      },
      {
        name: "Gyeon Q² Pure",
        brand: "Gyeon",
        description: "Professionele coating met uitstekende hydrofobische eigenschappen",
        image: "https://images.unsplash.com/photo-1507136566006-cfc505b114fc?q=80&w=2574&auto=format&fit=crop"
      }
    ],
    certifications: [
      {
        name: "Gtechniq Accredited",
        issuer: "Gtechniq",
        validUntil: "2025-12-31",
        image: "https://images.unsplash.com/photo-1507136566006-cfc505b114fc?q=80&w=2574&auto=format&fit=crop"
      },
      {
        name: "Gyeon Certified",
        issuer: "Gyeon",
        validUntil: "2025-12-31",
        image: "https://images.unsplash.com/photo-1507136566006-cfc505b114fc?q=80&w=2574&auto=format&fit=crop"
      }
    ],
    packages: [
      {
        name: "Basic Detailing",
        price: "€299",
        description: "Basis detailing pakket",
        features: [
          "Uitgebreide wasbeurt",
          "Interieur reiniging",
          "Basis polijsten",
          "Basis coating"
        ],
        buttonText: "Selecteer pakket"
      },
      {
        name: "Premium Detailing",
        price: "€599",
        description: "Uitgebreid detailing pakket",
        features: [
          "Basic Detailing +",
          "Paint correction",
          "Premium coating",
          "Interieur behandeling"
        ],
        buttonText: "Selecteer pakket",
        isPopular: true
      },
      {
        name: "Ultimate Detailing",
        price: "€999",
        description: "Complete detailing pakket",
        features: [
          "Premium Detailing +",
          "Full paint correction",
          "Keramische coating",
          "Interieur bescherming"
        ],
        buttonText: "Selecteer pakket"
      }
    ],
    guarantee: {
      duration: "5 jaar",
      coverage: ["Coating en werkzaamheden"],
      terms: ["Bij normaal gebruik en onderhoud"]
    },
    qualityStandards: [
      {
        name: "Inspectie",
        description: "Uitgebreide voor- en na inspectie",
        icon: "🔍"
      },
      {
        name: "Materialen",
        description: "Alleen premium producten",
        icon: "✨"
      },
      {
        name: "Training",
        description: "Gecertificeerde specialisten",
        icon: "🎓"
      }
    ],
    maintenanceTips: [
      {
        title: "Regelmatig wassen",
        description: "Was uw auto minimaal 1x per maand",
        frequency: "Maandelijks",
        importance: "high"
      },
      {
        title: "Coating onderhoud",
        description: "Breng booster aan om de coating te versterken",
        frequency: "6 maanden",
        importance: "medium"
      },
      {
        title: "Interieur reiniging",
        description: "Stofzuig en reinig het interieur regelmatig",
        frequency: "Maandelijks",
        importance: "medium"
      }
    ],
    relatedServices: [
      {
        id: "coating",
        title: "Coating",
        description: "Premium keramische coating",
        price: "Vanaf €499",
        image: "https://images.unsplash.com/photo-1507136566006-cfc505b114fc?q=80&w=2574&auto=format&fit=crop"
      },
      {
        id: "ppf-wrap",
        title: "PPF & Wrap",
        description: "Paint Protection Film",
        price: "Vanaf €1.499",
        image: "https://images.unsplash.com/photo-1611566026373-c6c8da0ea861?q=80&w=2574&auto=format&fit=crop"
      }
    ]
  },
  "onderhoud": {
    id: "onderhoud",
    title: "ONDERHOUD",
    subtitle: "Premium Service",
    description: "Vermado Automotive biedt specialistisch onderhoud voor exclusieve en high-performance voertuigen. Onze gecertificeerde technici begrijpen de complexiteit en specificiteit van premium auto's en zorgen ervoor dat uw investering in optimale conditie blijft. Met geavanceerde diagnostische apparatuur en uitsluitend originele of hoogwaardige OEM onderdelen garanderen wij een onderhoudservaring die voldoet aan de hoogste standaarden, zodat uw voertuig blijft presteren zoals het hoort.",
    image: "https://images.unsplash.com/photo-1486262715619-67b85e0b08d3?q=80&w=2574&auto=format&fit=crop",
    benefits: [
      "Behoud van fabrieksgarantie door gebruik van originele onderdelen",
      "Preventief onderhoud voorkomt grotere problemen",
      "Complete digitale onderhoudshistorie",
      "Voorrang bij storingen en snelle service",
      "Expertise in exclusieve en high-performance voertuigen"
    ],
    process: [
      "Uitgebreide inspectie van alle cruciale systemen",
      "Gedetailleerde diagnose met geavanceerde apparatuur",
      "Onderhoud volgens fabrieksspecificaties of uitgebreider",
      "Gebruik van uitsluitend premium oliën en onderdelen",
      "Uitgebreide kwaliteitscontrole na service"
    ],
    materials: [
      {
        name: "Motul 300V",
        brand: "Motul",
        description: "High-performance motorolie voor maximale bescherming",
        image: "https://images.unsplash.com/photo-1486262715619-67b85e0b08d3?q=80&w=2574&auto=format&fit=crop"
      },
      {
        name: "Textar Remmen",
        brand: "Textar",
        description: "Premium remonderdelen voor optimale veiligheid",
        image: "https://images.unsplash.com/photo-1486262715619-67b85e0b08d3?q=80&w=2574&auto=format&fit=crop"
      }
    ],
    certifications: [
      {
        name: "Master Technician",
        issuer: "Automotive Institute",
        validUntil: "2025-12-31",
        image: "https://images.unsplash.com/photo-1486262715619-67b85e0b08d3?q=80&w=2574&auto=format&fit=crop"
      },
      {
        name: "Performance Specialist",
        issuer: "Race Academy",
        validUntil: "2025-12-31",
        image: "https://images.unsplash.com/photo-1486262715619-67b85e0b08d3?q=80&w=2574&auto=format&fit=crop"
      }
    ],
    statistics: {
      projectsCompleted: 10000,
      yearsExperience: 20,
      satisfactionRate: 98,
      clientsServed: 8000
    },
    packages: [
      {
        name: "Basic Service",
        price: "€299",
        description: "Basis onderhoudsbeurt",
        features: [
          "Olie verversen",
          "Filters vervangen",
          "Diagnose check",
          "Vloeistoffen check"
        ],
        buttonText: "Selecteer pakket"
      },
      {
        name: "Performance Service",
        price: "€599",
        description: "Uitgebreide onderhoudsbeurt",
        features: [
          "Basic Service +",
          "Remmen check",
          "Uitlijning",
          "Performance scan"
        ],
        buttonText: "Selecteer pakket",
        isPopular: true
      },
      {
        name: "Race Service",
        price: "€999",
        description: "Complete race voorbereiding",
        features: [
          "Performance Service +",
          "Race inspectie",
          "Setup optimalisatie",
          "Track support"
        ],
        buttonText: "Selecteer pakket"
      }
    ],
    faq: [
      {
        category: "Service",
        question: "Hoe vaak moet ik mijn auto laten onderhouden?",
        answer: "Dit hangt af van uw rijstijl en gebruik, gemiddeld elke 10.000 km of jaarlijks."
      },
      {
        category: "Onderdelen",
        question: "Welke onderdelen worden gebruikt?",
        answer: "We gebruiken alleen A-merk onderdelen en OEM+ voor gemodificeerde auto's."
      },
      {
        category: "Garantie",
        question: "Wat is de garantie op onderhoud?",
        answer: "2 jaar garantie op onderdelen en arbeid bij normaal gebruik."
      },
      {
        category: "Planning",
        question: "Hoe lang duurt een onderhoudsbeurt?",
        answer: "Gemiddeld 1 werkdag, bij grotere werkzaamheden communiceren we dit vooraf."
      }
    ],
    relatedServices: [
      {
        id: "chiptuning",
        title: "Chiptuning",
        description: "Optimaliseer uw motor prestaties",
        price: "Vanaf €499",
        image: "https://images.unsplash.com/photo-1486262715619-67b85e0b08d3?q=80&w=2574&auto=format&fit=crop"
      },
      {
        id: "detailing",
        title: "Detailing",
        description: "Professionele reiniging en verzorging",
        price: "Vanaf €299",
        image: "https://images.unsplash.com/photo-1486262715619-67b85e0b08d3?q=80&w=2574&auto=format&fit=crop"
      }
    ],
    guarantee: {
      duration: "2 jaar garantie",
      coverage: [
        "Onderdelen",
        "Arbeid",
        "Diagnose",
        "Afstelling"
      ],
      terms: [
        "Bij normaal gebruik",
        "Volgens onderhoudsschema",
        "Geen race gebruik"
      ]
    },
    qualityStandards: [
      {
        icon: "🔧",
        name: "OEM+ Tools",
        description: "Gebruik van specialistische gereedschappen"
      },
      {
        icon: "📊",
        name: "Diagnose",
        description: "Uitgebreide diagnose met moderne apparatuur"
      },
      {
        icon: "👨‍🔧",
        name: "Expertise",
        description: "Ervaren monteurs met specialistische kennis"
      }
    ],
    maintenanceTips: [
      {
        title: "Olie Check",
        description: "Controleer regelmatig het oliepeil",
        importance: "high",
        frequency: "Maandelijks"
      },
      {
        title: "Bandenspanning",
        description: "Check de bandenspanning bij koude banden",
        importance: "medium",
        frequency: "Maandelijks"
      },
      {
        title: "Vloeistoffen",
        description: "Controleer alle vloeistofniveaus",
        importance: "low",
        frequency: "Elk kwartaal"
      }
    ]
  },
  "autohotel": {
    id: "autohotel",
    title: "AUTOHOTEL",
    subtitle: "Veilige Stalling",
    description: "Premium stalling voor uw waardevolle voertuigen in een beveiligde omgeving met klimaatcontrole en 24/7 bewaking.",
    image: "https://images.unsplash.com/photo-1581362072978-14998d01fdaa?q=80&w=2940&auto=format&fit=crop",
    benefits: [
      "24/7 beveiliging en videobewaking",
      "Klimaatgecontroleerde omgeving",
      "Regelmatige controle en onderhoud tijdens stalling",
      "Flexibele toegang op afspraak",
      "Opladen van accu en bandenspanning"
    ],
    process: [
      "Intake en conditie-inspectie van uw voertuig",
      "Professionele reiniging voor opslag",
      "Plaatsing in geconditioneerde ruimte",
      "Periodieke controles en onderhoud",
      "Flexibele ophaal- en brengservice"
    ],
    specifications: [
      {
        name: "Beveiliging",
        value: "24/7",
        description: "Continue camerabewaking en alarmsystemen"
      },
      {
        name: "Klimaat",
        value: "Optimaal",
        description: "Temperatuur en luchtvochtigheid gecontroleerd"
      },
      {
        name: "Service",
        value: "All-in",
        description: "Inclusief basis onderhoud en checks"
      },
      {
        name: "Toegang",
        value: "Flexibel",
        description: "Op afspraak 7 dagen per week"
      }
    ],
    materials: [
      {
        name: "CTEK Acculader",
        brand: "CTEK",
        description: "Professionele accu onderhoudssystemen",
        image: "https://images.unsplash.com/photo-1580273916550-e323be2ae537?q=80&w=2940&auto=format&fit=crop"
      },
      {
        name: "Car Cover Premium",
        brand: "Coverking",
        description: "Ademende autohoes op maat gemaakt",
        image: "https://images.unsplash.com/photo-1580273916550-e323be2ae537?q=80&w=2940&auto=format&fit=crop"
      }
    ],
    certifications: [
      {
        name: "ISO 27001",
        issuer: "ISO",
        validUntil: "2025-12-31",
        image: "https://images.unsplash.com/photo-1580273916550-e323be2ae537?q=80&w=2940&auto=format&fit=crop"
      },
      {
        name: "VCA Security",
        issuer: "VCA",
        validUntil: "2025-12-31",
        image: "https://images.unsplash.com/photo-1580273916550-e323be2ae537?q=80&w=2940&auto=format&fit=crop"
      }
    ],
    statistics: {
      projectsCompleted: 500,
      yearsExperience: 10,
      satisfactionRate: 99,
      clientsServed: 400
    },
    packages: [
      {
        name: "Basic Storage",
        price: "€199/maand",
        description: "Basis stalling pakket",
        features: [
          "Beveiligde stalling",
          "Klimaatcontrole",
          "Maandelijkse check",
          "Accu onderhoud"
        ],
        buttonText: "Selecteer pakket"
      },
      {
        name: "Premium Storage",
        price: "€299/maand",
        description: "Premium stalling met extra services",
        features: [
          "Basic Storage +",
          "Wekelijkse check",
          "Wasservice",
          "Haal- en brengservice"
        ],
        buttonText: "Selecteer pakket",
        isPopular: true
      },
      {
        name: "Exclusive Storage",
        price: "€499/maand",
        description: "All-inclusive stalling en onderhoud",
        features: [
          "Premium Storage +",
          "24/7 toegang",
          "Volledig onderhoud",
          "Detailing service"
        ],
        buttonText: "Selecteer pakket"
      }
    ],
    faq: [
      {
        category: "Toegang",
        question: "Hoe kan ik mijn auto ophalen?",
        answer: "U kunt 7 dagen per week op afspraak uw auto ophalen en terugbrengen."
      },
      {
        category: "Beveiliging",
        question: "Hoe is de beveiliging geregeld?",
        answer: "24/7 camerabewaking, alarmsystemen en beveiligingspersoneel."
      },
      {
        category: "Onderhoud",
        question: "Wat houdt het onderhoud in?",
        answer: "Regelmatige checks, accu onderhoud en indien gewenst complete service."
      },
      {
        category: "Verzekering",
        question: "Is mijn auto verzekerd tijdens stalling?",
        answer: "Ja, we hebben een uitgebreide verzekering voor alle gestalde voertuigen."
      }
    ],
    relatedServices: [
      {
        id: "detailing",
        title: "Detailing",
        description: "Professionele reiniging tijdens stalling",
        price: "Vanaf €299",
        image: "https://images.unsplash.com/photo-1580273916550-e323be2ae537?q=80&w=2940&auto=format&fit=crop"
      },
      {
        id: "onderhoud",
        title: "Onderhoud",
        description: "Compleet onderhoud tijdens stalling",
        price: "Vanaf €199",
        image: "https://images.unsplash.com/photo-1580273916550-e323be2ae537?q=80&w=2940&auto=format&fit=crop"
      }
    ],
    guarantee: {
      duration: "100% tevredenheidsgarantie",
      coverage: [
        "Beveiliging",
        "Klimaatbeheersing",
        "Onderhoud",
        "Service"
      ],
      terms: [
        "Minimaal 3 maanden",
        "Opzegtermijn 1 maand",
        "Volgens huisreglement"
      ]
    },
    qualityStandards: [
      {
        icon: "🔒",
        name: "24/7 Beveiliging",
        description: "Continue bewaking en monitoring"
      },
      {
        icon: "🌡️",
        name: "Klimaatcontrole",
        description: "Optimale omstandigheden voor uw auto"
      },
      {
        icon: "👨‍🔧",
        name: "Expertise",
        description: "Professioneel team van specialisten"
      }
    ],
    maintenanceTips: [
      {
        title: "Accu Check",
        description: "Regelmatige controle van de accu spanning",
        importance: "high",
        frequency: "Wekelijks"
      },
      {
        title: "Bandenspanning",
        description: "Controle en aanpassing van de bandenspanning",
        importance: "medium",
        frequency: "Maandelijks"
      },
      {
        title: "Visuele Inspectie",
        description: "Check op lekkages of andere problemen",
        importance: "low",
        frequency: "Maandelijks"
      }
    ]
  },
  "verkoop": {
    id: "verkoop",
    title: "VERKOOP",
    subtitle: "Premium Occasions",
    description: "Exclusieve selectie van premium voertuigen voor de veeleisende koper. Zorgvuldig geselecteerd en gecontroleerd op kwaliteit en historie.",
    image: "https://images.unsplash.com/photo-1560179707-f14e90ef3623?q=80&w=2940&auto=format&fit=crop",
    benefits: [
      "Strenge selectiecriteria voor alle aangeboden voertuigen",
      "Volledige technische inspectie en historie-check",
      "Transparante documentatie en onderhoudshistorie",
      "Mogelijkheid tot inruil en financiering",
      "Nazorg en ondersteuning na aankoop"
    ],
    process: [
      "Uitgebreide intake en selectieprocedure",
      "Technische controle op 100+ punten",
      "Professionele detailing en voorbereiding",
      "Transparante presentatie met alle details",
      "Persoonlijke begeleiding bij aankoop"
    ],
    specifications: [
      {
        name: "Selectie",
        value: "Premium",
        description: "Zorgvuldig geselecteerde voertuigen"
      },
      {
        name: "Historie",
        value: "100%",
        description: "Volledige onderhoudshistorie"
      },
      {
        name: "Inspectie",
        value: "150+ punten",
        description: "Uitgebreide technische keuring"
      },
      {
        name: "Garantie",
        value: "12-24 mnd",
        description: "Uitgebreide garantiemogelijkheden"
      }
    ],
    materials: [
      {
        name: "Diagnose Apparatuur",
        brand: "Bosch",
        description: "Professionele diagnoseapparatuur voor alle merken",
        image: "https://images.unsplash.com/photo-1549225747-0c5c8e18c88e?q=80&w=2940&auto=format&fit=crop"
      },
      {
        name: "Inspectie Tools",
        brand: "Snap-on",
        description: "Specialistische gereedschappen voor inspectie",
        image: "https://images.unsplash.com/photo-1549225747-0c5c8e18c88e?q=80&w=2940&auto=format&fit=crop"
      }
    ],
    certifications: [
      {
        name: "RDW Erkend",
        issuer: "RDW",
        validUntil: "2025-12-31",
        image: "https://images.unsplash.com/photo-1549225747-0c5c8e18c88e?q=80&w=2940&auto=format&fit=crop"
      },
      {
        name: "BOVAG Garantie",
        issuer: "BOVAG",
        validUntil: "2025-12-31",
        image: "https://images.unsplash.com/photo-1549225747-0c5c8e18c88e?q=80&w=2940&auto=format&fit=crop"
      }
    ],
    statistics: {
      projectsCompleted: 1500,
      yearsExperience: 15,
      satisfactionRate: 98,
      clientsServed: 1200
    },
    packages: [
      {
        name: "Basic Garantie",
        price: "Inclusief",
        description: "Standaard garantiepakket",
        features: [
          "12 maanden garantie",
          "Pechhulp Europa",
          "150+ punten check",
          "Onderhoudshistorie"
        ],
        buttonText: "Selecteer pakket"
      },
      {
        name: "Premium Garantie",
        price: "€999",
        description: "Uitgebreid garantiepakket",
        features: [
          "24 maanden garantie",
          "Wereldwijde pechhulp",
          "Haal- en brengservice",
          "Vervangend vervoer"
        ],
        buttonText: "Selecteer pakket",
        isPopular: true
      },
      {
        name: "Ultimate Garantie",
        price: "€1.999",
        description: "Maximale zekerheid",
        features: [
          "36 maanden garantie",
          "All-risk dekking",
          "Gratis onderhoud",
          "Concierge service"
        ],
        buttonText: "Selecteer pakket"
      }
    ],
    faq: [
      {
        category: "Aankoop",
        question: "Hoe verloopt het aankoopproces?",
        answer: "We begeleiden u volledig, van bezichtiging tot aflevering en nazorg."
      },
      {
        category: "Garantie",
        question: "Wat houdt de garantie in?",
        answer: "Afhankelijk van het pakket 12-36 maanden garantie op technische defecten."
      },
      {
        category: "Financiering",
        question: "Zijn er financieringsmogelijkheden?",
        answer: "Ja, we bieden verschillende lease en financieringsopties aan."
      },
      {
        category: "Inruil",
        question: "Kan ik mijn huidige auto inruilen?",
        answer: "Ja, we bieden een eerlijke inruilprijs na taxatie."
      }
    ],
    relatedServices: [
      {
        id: "onderhoud",
        title: "Onderhoud",
        description: "Premium onderhoudspakketten",
        price: "Vanaf €299",
        image: "https://images.unsplash.com/photo-1549225747-0c5c8e18c88e?q=80&w=2940&auto=format&fit=crop"
      },
      {
        id: "modificaties",
        title: "Modificaties",
        description: "Personaliseer uw nieuwe auto",
        price: "Vanaf €1.999",
        image: "https://images.unsplash.com/photo-1549225747-0c5c8e18c88e?q=80&w=2940&auto=format&fit=crop"
      }
    ],
    guarantee: {
      duration: "Tot 36 maanden garantie",
      coverage: [
        "Technische defecten",
        "Elektronische componenten",
        "Aandrijflijn",
        "Assistentie"
      ],
      terms: [
        "Volgens onderhoudsschema",
        "Bij erkende dealer",
        "Normaal gebruik"
      ]
    },
    qualityStandards: [
      {
        icon: "🔍",
        name: "Inspectie",
        description: "Uitgebreide technische keuring"
      },
      {
        icon: "📋",
        name: "Documentatie",
        description: "Complete historie en documentatie"
      },
      {
        icon: "🛡️",
        name: "Garantie",
        description: "Uitgebreide garantiepakketten"
      }
    ],
    maintenanceTips: [
      {
        title: "Eerste Service",
        description: "Plan de eerste onderhoudsbeurt",
        importance: "high",
        frequency: "Na aankoop"
      },
      {
        title: "Garantie Check",
        description: "Regelmatige controle volgens garantievoorwaarden",
        importance: "medium",
        frequency: "Volgens schema"
      },
      {
        title: "Documentatie",
        description: "Bewaar alle service documentatie",
        importance: "low",
        frequency: "Doorlopend"
      }
    ]
  },
  "transport": {
    id: "transport",
    title: "AUTO TRANSPORT",
    subtitle: "Veilig Vervoer",
    description: "Professioneel en verzekerd transport van uw kostbare voertuigen. Met specialistische transportmiddelen en ervaren chauffeurs garanderen wij veilige levering.",
    image: "https://images.unsplash.com/photo-1589793907316-f94025b46850?q=80&w=2940&auto=format&fit=crop",
    benefits: [
      "Volledig verzekerd transport",
      "Gesloten of open transport mogelijk",
      "Discreet en veilig over heel Europa",
      "Real-time tracking van uw voertuig",
      "Ervaren chauffeurs met specifieke autotraining"
    ],
    process: [
      "Intake en risico-inventarisatie",
      "Planning en routebepaling",
      "Professionele vastzetprocedure",
      "Transport met regelmatige statusupdates",
      "Controle bij aflevering"
    ],
    specifications: [
      {
        name: "Dekking",
        value: "Europa",
        description: "Transport door heel Europa"
      },
      {
        name: "Verzekering",
        value: "All-Risk",
        description: "Volledig verzekerd transport"
      },
      {
        name: "Service",
        value: "24/7",
        description: "Altijd bereikbaar"
      },
      {
        name: "Tracking",
        value: "Real-time",
        description: "Live tracking van uw transport"
      }
    ],
    materials: [
      {
        name: "Enclosed Trailer",
        brand: "Cartransporter",
        description: "Gesloten autotransporter met klimaatbeheersing",
        image: "https://images.unsplash.com/photo-1586768035999-0e72a26c3afb?q=80&w=2940&auto=format&fit=crop"
      },
      {
        name: "Vastzetmateriaal",
        brand: "Mac's",
        description: "Professionele spansystemen voor veilig transport",
        image: "https://images.unsplash.com/photo-1586768035999-0e72a26c3afb?q=80&w=2940&auto=format&fit=crop"
      }
    ],
    certifications: [
      {
        name: "Transport Certificaat",
        issuer: "TLN",
        validUntil: "2025-12-31",
        image: "https://images.unsplash.com/photo-1586768035999-0e72a26c3afb?q=80&w=2940&auto=format&fit=crop"
      },
      {
        name: "ISO 9001",
        issuer: "ISO",
        validUntil: "2025-12-31",
        image: "https://images.unsplash.com/photo-1586768035999-0e72a26c3afb?q=80&w=2940&auto=format&fit=crop"
      }
    ],
    statistics: {
      projectsCompleted: 5000,
      yearsExperience: 15,
      satisfactionRate: 99,
      clientsServed: 2000
    },
    packages: [
      {
        name: "Nationaal Transport",
        price: "€299",
        description: "Transport binnen Nederland",
        features: [
          "Gesloten transport",
          "Verzekerd vervoer",
          "GPS tracking",
          "Deur tot deur"
        ],
        buttonText: "Selecteer pakket"
      },
      {
        name: "Internationaal Transport",
        price: "€999",
        description: "Transport binnen Europa",
        features: [
          "Gesloten transport",
          "All-risk verzekering",
          "24/7 support",
          "Douane service"
        ],
        buttonText: "Selecteer pakket",
        isPopular: true
      },
      {
        name: "Premium Transport",
        price: "€1.999",
        description: "VIP transport service",
        features: [
          "Dedicated transport",
          "Klimaatbeheersing",
          "Persoonlijke begeleiding",
          "Priority service"
        ],
        buttonText: "Selecteer pakket"
      }
    ],
    faq: [
      {
        category: "Planning",
        question: "Hoe ver vooraf moet ik boeken?",
        answer: "Voor nationale transporten 48 uur, internationaal minimaal 5 werkdagen."
      },
      {
        category: "Verzekering",
        question: "Hoe is mijn auto verzekerd?",
        answer: "All-risk verzekering tijdens transport met uitgebreide dekking."
      },
      {
        category: "Track & Trace",
        question: "Kan ik mijn transport volgen?",
        answer: "Ja, u krijgt toegang tot ons live tracking systeem."
      },
      {
        category: "Documentatie",
        question: "Welke documenten zijn nodig?",
        answer: "Kentekenbewijs, legitimatie en transportopdracht."
      }
    ],
    relatedServices: [
      {
        id: "autohotel",
        title: "Autohotel",
        description: "Tijdelijke stalling voor of na transport",
        price: "Vanaf €99",
        image: "https://images.unsplash.com/photo-1586768035999-0e72a26c3afb?q=80&w=2940&auto=format&fit=crop"
      },
      {
        id: "detailing",
        title: "Detailing",
        description: "Reiniging voor transport",
        price: "Vanaf €199",
        image: "https://images.unsplash.com/photo-1586768035999-0e72a26c3afb?q=80&w=2940&auto=format&fit=crop"
      }
    ],
    guarantee: {
      duration: "Transport garantie",
      coverage: [
        "Schade",
        "Vertraging",
        "Diefstal",
        "Assistentie"
      ],
      terms: [
        "Volgens voorwaarden",
        "Bij normaal gebruik",
        "Binnen Europa"
      ]
    },
    qualityStandards: [
      {
        icon: "🚛",
        name: "Premium Transport",
        description: "Gesloten transport met klimaatbeheersing"
      },
      {
        icon: "🔒",
        name: "Verzekerd",
        description: "All-risk verzekering tijdens transport"
      },
      {
        icon: "📍",
        name: "Tracking",
        description: "Real-time tracking en monitoring"
      }
    ],
    maintenanceTips: [
      {
        title: "Inspectie",
        description: "Check de auto voor transport",
        importance: "high",
        frequency: "Voor transport"
      },
      {
        title: "Documentatie",
        description: "Zorg voor alle benodigde papieren",
        importance: "medium",
        frequency: "Voor transport"
      },
      {
        title: "Brandstof",
        description: "Zorg voor voldoende brandstof",
        importance: "low",
        frequency: "Voor transport"
      }
    ]
  },
  "bandenhotel": {
    id: "bandenhotel",
    title: "BANDENHOTEL",
    subtitle: "Seizoensopslag",
    description: "Professionele opslag en beheer van uw winter- en zomerbanden in een geconditioneerde omgeving voor maximale levensduur.",
    image: "https://lozejxkhsvwkksgzhrfd.supabase.co/storage/v1/object/public/images//bandenhotel.jpg",
    benefits: [
      "Verlenging van de levensduur van uw banden",
      "Geen opslagruimte nodig in uw garage of schuur",
      "Professionele montage en balancering bij wissel",
      "Regelmatige controle van conditie en profieldiepte",
      "Uitgebreide bandenverzekering tijdens opslag"
    ],
    process: [
      "Demontage en controle van de banden/velgen",
      "Professionele reiniging en behandeling",
      "Registratie en labeling voor eenvoudige identificatie",
      "Opslag in ideale omstandigheden",
      "Montage en balancering bij seizoenswisseling"
    ],
    specifications: [
      {
        name: "Opslag",
        value: "Klimaat",
        description: "Klimaatgecontroleerde opslag"
      },
      {
        name: "Service",
        value: "All-in",
        description: "Inclusief wissel en balanceren"
      },
      {
        name: "Inspectie",
        value: "100%",
        description: "Uitgebreide bandencontrole"
      },
      {
        name: "Garantie",
        value: "Volledig",
        description: "Verzekerde opslag"
      }
    ],
    materials: [
      {
        name: "Hunter Balanceerapparaat",
        brand: "Hunter",
        description: "Professionele balancering voor optimale prestaties",
        image: "https://images.unsplash.com/photo-1486262715619-67b85e0b08d3?q=80&w=2574&auto=format&fit=crop"
      },
      {
        name: "Opslag Systeem",
        brand: "Rema",
        description: "Geautomatiseerd opslagsysteem voor banden",
        image: "https://images.unsplash.com/photo-1486262715619-67b85e0b08d3?q=80&w=2574&auto=format&fit=crop"
      }
    ],
    certifications: [
      {
        name: "VACO Certified",
        issuer: "VACO",
        validUntil: "2025-12-31",
        image: "https://images.unsplash.com/photo-1486262715619-67b85e0b08d3?q=80&w=2574&auto=format&fit=crop"
      },
      {
        name: "ISO 9001",
        issuer: "ISO",
        validUntil: "2025-12-31",
        image: "https://images.unsplash.com/photo-1486262715619-67b85e0b08d3?q=80&w=2574&auto=format&fit=crop"
      }
    ],
    statistics: {
      projectsCompleted: 5000,
      yearsExperience: 10,
      satisfactionRate: 99,
      clientsServed: 4000
    },
    packages: [
      {
        name: "Basic Storage",
        price: "€99/seizoen",
        description: "Basis opslag service",
        features: [
          "Opslag 4 banden/velgen",
          "Basis inspectie",
          "Wissel service",
          "Basis verzekering"
        ],
        buttonText: "Selecteer pakket"
      },
      {
        name: "Premium Storage",
        price: "€149/seizoen",
        description: "Premium opslag service",
        features: [
          "Basic Storage +",
          "Uitgebreide inspectie",
          "Balanceren",
          "Haal- en brengservice"
        ],
        buttonText: "Selecteer pakket",
        isPopular: true
      },
      {
        name: "Ultimate Storage",
        price: "€199/seizoen",
        description: "Complete opslag service",
        features: [
          "Premium Storage +",
          "24/7 toegang",
          "Cleaning service",
          "Priority service"
        ],
        buttonText: "Selecteer pakket"
      }
    ],
    faq: [
      {
        category: "Opslag",
        question: "Hoe worden mijn banden opgeslagen?",
        answer: "In een klimaatgecontroleerde ruimte onder optimale omstandigheden."
      },
      {
        category: "Service",
        question: "Wat is inbegrepen bij de wissel?",
        answer: "Professionele montage, balanceren en controle van de banden."
      },
      {
        category: "Planning",
        question: "Wanneer kan ik wisselen?",
        answer: "We adviseren tussen oktober-november en maart-april."
      },
      {
        category: "Verzekering",
        question: "Zijn mijn banden verzekerd?",
        answer: "Ja, alle opgeslagen banden zijn volledig verzekerd."
      }
    ],
    relatedServices: [
      {
        id: "onderhoud",
        title: "Onderhoud",
        description: "Complete autoservice",
        price: "Vanaf €299",
        image: "https://images.unsplash.com/photo-1486262715619-67b85e0b08d3?q=80&w=2574&auto=format&fit=crop"
      },
      {
        id: "uitlijning",
        title: "Uitlijning",
        description: "Professionele wieluitlijning",
        price: "Vanaf €89",
        image: "https://images.unsplash.com/photo-1486262715619-67b85e0b08d3?q=80&w=2574&auto=format&fit=crop"
      }
    ],
    guarantee: {
      duration: "Seizoensgarantie",
      coverage: [
        "Opslag",
        "Montage",
        "Balancering",
        "Transport"
      ],
      terms: [
        "Per seizoen",
        "Bij normaal gebruik",
        "Volgens voorwaarden"
      ]
    },
    qualityStandards: [
      {
        icon: "🌡️",
        name: "Klimaatcontrole",
        description: "Optimale opslagcondities"
      },
      {
        icon: "🔧",
        name: "Professionele Service",
        description: "Gecertificeerde monteurs"
      },
      {
        icon: "📊",
        name: "Tracking Systeem",
        description: "Digitaal bandenmanagement"
      }
    ],
    maintenanceTips: [
      {
        title: "Bandenspanning",
        description: "Controleer regelmatig de bandenspanning",
        importance: "high",
        frequency: "Maandelijks"
      },
      {
        title: "Profieldiepte",
        description: "Check de profieldiepte voor veiligheid",
        importance: "medium",
        frequency: "Per seizoen"
      },
      {
        title: "Visuele Inspectie",
        description: "Controleer op beschadigingen",
        importance: "low",
        frequency: "Bij wissel"
      }
    ]
  },
  "shop": {
    id: "shop",
    title: "SHOP",
    subtitle: "Premium Producten",
    description: "Exclusieve selectie van hoogwaardige automotive producten en accessoires. Zorgvuldig geselecteerd door onze specialisten voor optimale kwaliteit en resultaat.",
    image: "https://lozejxkhsvwkksgzhrfd.supabase.co/storage/v1/object/public/images//shop.jpg",
    benefits: [
      "Uitsluitend premium merken en producten",
      "Persoonlijk advies van productspecialisten",
      "Exclusieve producten die niet in reguliere winkels verkrijgbaar zijn",
      "Demonstraties en workshops mogelijk",
      "Uitgebreide after-sales service"
    ],
    process: [
      "Persoonlijke behoefteanalyse",
      "Deskundig productadvies",
      "Demonstratie van geselecteerde producten",
      "Instructie voor correct gebruik",
      "Nazorg en ondersteuning"
    ],
    specifications: [
      {
        name: "Assortiment",
        value: "1000+",
        description: "Uitgebreide collectie producten"
      },
      {
        name: "Kwaliteit",
        value: "Premium",
        description: "Alleen A-merk producten"
      },
      {
        name: "Levering",
        value: "24-48u",
        description: "Snelle levering mogelijk"
      },
      {
        name: "Advies",
        value: "Expert",
        description: "Persoonlijk productadvies"
      }
    ],
    materials: [
      {
        name: "Detailing Producten",
        brand: "Gyeon",
        description: "Premium car care producten",
        image: "https://images.unsplash.com/photo-1486262715619-67b85e0b08d3?q=80&w=2574&auto=format&fit=crop"
      },
      {
        name: "Performance Parts",
        brand: "K&N",
        description: "Hoogwaardige performance onderdelen",
        image: "https://images.unsplash.com/photo-1486262715619-67b85e0b08d3?q=80&w=2574&auto=format&fit=crop"
      }
    ],
    certifications: [
      {
        name: "Authorized Dealer",
        issuer: "Multiple Brands",
        validUntil: "2025-12-31",
        image: "https://images.unsplash.com/photo-1486262715619-67b85e0b08d3?q=80&w=2574&auto=format&fit=crop"
      },
      {
        name: "Webshop Keurmerk",
        issuer: "Thuiswinkel",
        validUntil: "2025-12-31",
        image: "https://images.unsplash.com/photo-1486262715619-67b85e0b08d3?q=80&w=2574&auto=format&fit=crop"
      }
    ],
    statistics: {
      projectsCompleted: 10000,
      yearsExperience: 8,
      satisfactionRate: 98,
      clientsServed: 8000
    },
    packages: [
      {
        name: "Starter Kit",
        price: "€99",
        description: "Basis verzorgingsset",
        features: [
          "Shampoo",
          "Microvezel doeken",
          "Wax",
          "Reiniger"
        ],
        buttonText: "Selecteer pakket"
      },
      {
        name: "Pro Kit",
        price: "€249",
        description: "Professionele verzorgingsset",
        features: [
          "Starter Kit +",
          "Coating",
          "Polijstmachine",
          "Accessoires"
        ],
        buttonText: "Selecteer pakket",
        isPopular: true
      },
      {
        name: "Ultimate Kit",
        price: "€499",
        description: "Complete verzorgingsset",
        features: [
          "Pro Kit +",
          "Keramische coating",
          "Pro tools",
          "Training"
        ],
        buttonText: "Selecteer pakket"
      }
    ],
    faq: [
      {
        category: "Producten",
        question: "Zijn alle producten origineel?",
        answer: "Ja, we verkopen uitsluitend originele producten van A-merken."
      },
      {
        category: "Levering",
        question: "Hoe snel wordt er geleverd?",
        answer: "Binnen 24-48 uur bij voorraadproducten."
      },
      {
        category: "Garantie",
        question: "Wat is de garantie?",
        answer: "Minimaal 2 jaar garantie op alle producten."
      },
      {
        category: "Advies",
        question: "Kan ik advies krijgen?",
        answer: "Ja, onze experts staan klaar voor persoonlijk advies."
      }
    ],
    relatedServices: [
      {
        id: "detailing",
        title: "Detailing",
        description: "Professionele autodetailing",
        price: "Vanaf €299",
        image: "https://images.unsplash.com/photo-1486262715619-67b85e0b08d3?q=80&w=2574&auto=format&fit=crop"
      },
      {
        id: "coating",
        title: "Coating",
        description: "Keramische coating service",
        price: "Vanaf €699",
        image: "https://images.unsplash.com/photo-1486262715619-67b85e0b08d3?q=80&w=2574&auto=format&fit=crop"
      }
    ],
    guarantee: {
      duration: "2 jaar garantie",
      coverage: [
        "Productdefecten",
        "Materiaalfouten",
        "Performance",
        "Authenticiteit"
      ],
      terms: [
        "Bij normaal gebruik",
        "Volgens voorschrift",
        "Originele verpakking"
      ]
    },
    qualityStandards: [
      {
        icon: "✨",
        name: "Premium Kwaliteit",
        description: "Alleen A-merk producten"
      },
      {
        icon: "🛡️",
        name: "Garantie",
        description: "Uitgebreide garantie op alle producten"
      },
      {
        icon: "👨‍🔬",
        name: "Expert Advies",
        description: "Persoonlijk advies van specialisten"
      }
    ],
    maintenanceTips: [
      {
        title: "Productgebruik",
        description: "Volg de gebruiksaanwijzing nauwkeurig",
        importance: "high",
        frequency: "Bij elk gebruik"
      },
      {
        title: "Opslag",
        description: "Bewaar producten op de juiste temperatuur",
        importance: "medium",
        frequency: "Continu"
      },
      {
        title: "Onderhoud Tools",
        description: "Reinig en onderhoud gebruikte tools",
        importance: "low",
        frequency: "Na gebruik"
      }
    ]
  },
  "restyle": {
    id: "restyle",
    title: "RESTYLE",
    subtitle: "Custom Design",
    description: "Unieke styling en personalisatie voor uw voertuig, van subtiele accenten tot complete designveranderingen. Wij creëren een voertuig dat uw persoonlijkheid uitstraalt.",
    image: "https://lozejxkhsvwkksgzhrfd.supabase.co/storage/v1/object/public/images//restyle.jpg",
    benefits: [
      "Volledig op maat gemaakte styling oplossingen",
      "Combinatie van esthetische en functionele upgrades",
      "Hoogwaardige materialen met lange levensduur",
      "Behoud van originele elementen waar gewenst",
      "Unieke uitstraling die uw voertuig onderscheidt"
    ],
    process: [
      "Creatieve consultatie en ontwerpsessie",
      "3D-visualisatie van het eindresultaat",
      "Selectie van materialen en onderdelen",
      "Gefaseerde uitvoering met tussentijdse controles",
      "Professionele fotoshoot van het eindresultaat"
    ],
    specifications: [
      {
        name: "Customization",
        value: "100%",
        description: "Volledig maatwerk mogelijk"
      },
      {
        name: "Materialen",
        value: "Premium",
        description: "Hoogwaardige materialen"
      },
      {
        name: "Garantie",
        value: "5 jaar",
        description: "Uitgebreide garantie"
      },
      {
        name: "Design",
        value: "Custom",
        description: "Unieke ontwerpen"
      }
    ],
    materials: [
      {
        name: "3M Vinyl",
        brand: "3M",
        description: "Premium vinyl voor wrapping",
        image: "https://images.unsplash.com/photo-1486262715619-67b85e0b08d3?q=80&w=2574&auto=format&fit=crop"
      },
      {
        name: "Carbon Parts",
        brand: "Various",
        description: "Hoogwaardige carbon onderdelen",
        image: "https://images.unsplash.com/photo-1486262715619-67b85e0b08d3?q=80&w=2574&auto=format&fit=crop"
      }
    ],
    certifications: [
      {
        name: "3M Certified",
        issuer: "3M",
        validUntil: "2025-12-31",
        image: "https://images.unsplash.com/photo-1486262715619-67b85e0b08d3?q=80&w=2574&auto=format&fit=crop"
      },
      {
        name: "Custom Design",
        issuer: "SEMA",
        validUntil: "2025-12-31",
        image: "https://images.unsplash.com/photo-1486262715619-67b85e0b08d3?q=80&w=2574&auto=format&fit=crop"
      }
    ],
    statistics: {
      projectsCompleted: 2000,
      yearsExperience: 12,
      satisfactionRate: 99,
      clientsServed: 1500
    },
    packages: [
      {
        name: "Basic Restyle",
        price: "€1.499",
        description: "Basis styling pakket",
        features: [
          "Spoiler kit",
          "Side skirts",
          "Velgen upgrade",
          "Basis wrapping"
        ],
        buttonText: "Selecteer pakket"
      },
      {
        name: "Premium Restyle",
        price: "€3.499",
        description: "Uitgebreid styling pakket",
        features: [
          "Basic Restyle +",
          "Full body kit",
          "Custom paint",
          "Interior upgrade"
        ],
        buttonText: "Selecteer pakket",
        isPopular: true
      },
      {
        name: "Ultimate Restyle",
        price: "€7.499",
        description: "Complete transformatie",
        features: [
          "Premium Restyle +",
          "Custom bodywork",
          "Performance upgrades",
          "Exclusive design"
        ],
        buttonText: "Selecteer pakket"
      }
    ],
    faq: [
      {
        category: "Design",
        question: "Kan ik mijn eigen design aanleveren?",
        answer: "Ja, we werken graag met uw eigen ontwerpen."
      },
      {
        category: "Materialen",
        question: "Welke materialen worden gebruikt?",
        answer: "Uitsluitend premium materialen van topmerken."
      },
      {
        category: "Garantie",
        question: "Hoelang is de garantie?",
        answer: "5 jaar op materiaal en montage."
      },
      {
        category: "Planning",
        question: "Wat is de doorlooptijd?",
        answer: "Afhankelijk van het pakket 3-14 dagen."
      }
    ],
    relatedServices: [
      {
        id: "wrapping",
        title: "Car Wrapping",
        description: "Complete car wraps",
        price: "Vanaf €2.499",
        image: "https://images.unsplash.com/photo-1486262715619-67b85e0b08d3?q=80&w=2574&auto=format&fit=crop"
      },
      {
        id: "coating",
        title: "Coating",
        description: "Beschermende coating",
        price: "Vanaf €699",
        image: "https://images.unsplash.com/photo-1486262715619-67b85e0b08d3?q=80&w=2574&auto=format&fit=crop"
      }
    ],
    guarantee: {
      duration: "5 jaar garantie",
      coverage: [
        "Materialen",
        "Montage",
        "Afwerking",
        "Design"
      ],
      terms: [
        "Bij normaal gebruik",
        "Volgens onderhoudsvoorschrift",
        "Niet bij schade"
      ]
    },
    qualityStandards: [
      {
        icon: "🎨",
        name: "Custom Design",
        description: "Unieke ontwerpen op maat"
      },
      {
        icon: "🛠️",
        name: "Vakmanschap",
        description: "Ervaren specialisten"
      },
      {
        icon: "✨",
        name: "Premium Afwerking",
        description: "Perfecte afwerking"
      }
    ],
    maintenanceTips: [
      {
        title: "Reiniging",
        description: "Gebruik alleen aanbevolen producten",
        importance: "high",
        frequency: "Wekelijks"
      },
      {
        title: "Inspectie",
        description: "Check op beschadigingen",
        importance: "medium",
        frequency: "Maandelijks"
      },
      {
        title: "Bescherming",
        description: "Vermijd extreme omstandigheden",
        importance: "low",
        frequency: "Continu"
      }
    ]
  },

  "community": {
    id: "community",
    title: "COMMUNITY",
    subtitle: "Car Enthusiast Network",
    description: "Word deel van onze exclusieve automotive community. Events, meetings en expertise delen.",
    image: "https://lozejxkhsvwkksgzhrfd.supabase.co/storage/v1/object/public/images//community.jpg",
    specifications: [
      {
        name: "Leden",
        value: "1000+",
        description: "Actieve leden"
      },
      {
        name: "Events",
        value: "Monthly",
        description: "Regelmatige meetings"
      },
      {
        name: "Expertise",
        value: "Expert",
        description: "Kennisdeling"
      },
      {
        name: "Netwerk",
        value: "Premium",
        description: "Exclusief netwerk"
      }
    ],
    materials: [
      {
        name: "Event Locaties",
        brand: "Various",
        description: "Premium locaties voor meetings",
        image: "https://images.unsplash.com/photo-1486262715619-67b85e0b08d3?q=80&w=2574&auto=format&fit=crop"
      },
      {
        name: "Community Platform",
        brand: "Custom",
        description: "Online platform voor leden",
        image: "https://images.unsplash.com/photo-1486262715619-67b85e0b08d3?q=80&w=2574&auto=format&fit=crop"
      }
    ],
    certifications: [
      {
        name: "Official Club",
        issuer: "KNAC",
        validUntil: "2025-12-31",
        image: "https://images.unsplash.com/photo-1486262715619-67b85e0b08d3?q=80&w=2574&auto=format&fit=crop"
      },
      {
        name: "Event License",
        issuer: "FEHAC",
        validUntil: "2025-12-31",
        image: "https://images.unsplash.com/photo-1486262715619-67b85e0b08d3?q=80&w=2574&auto=format&fit=crop"
      }
    ],
    statistics: {
      projectsCompleted: 100,
      yearsExperience: 5,
      satisfactionRate: 98,
      clientsServed: 1000
    },
    packages: [
      {
        name: "Basic Membership",
        price: "€99/jaar",
        description: "Basis lidmaatschap",
        features: [
          "Online toegang",
          "Forum participatie",
          "Maandelijkse nieuwsbrief",
          "Event korting"
        ],
        buttonText: "Word lid"
      },
      {
        name: "Premium Membership",
        price: "€249/jaar",
        description: "Premium lidmaatschap",
        features: [
          "Basic Membership +",
          "VIP events",
          "Tech support",
          "Exclusieve deals"
        ],
        buttonText: "Word lid",
        isPopular: true
      },
      {
        name: "Ultimate Membership",
        price: "€499/jaar",
        description: "Ultimate lidmaatschap",
        features: [
          "Premium Membership +",
          "1-op-1 consulting",
          "Priority service",
          "Track days"
        ],
        buttonText: "Word lid"
      }
    ],
    faq: [
      {
        category: "Lidmaatschap",
        question: "Wat krijg ik als lid?",
        answer: "Toegang tot events, expertise en exclusieve deals."
      },
      {
        category: "Events",
        question: "Hoe vaak zijn er events?",
        answer: "Minimaal één keer per maand."
      },
      {
        category: "Platform",
        question: "Is er een online platform?",
        answer: "Ja, met forum en kennisbank."
      },
      {
        category: "Opzeggen",
        question: "Kan ik tussentijds opzeggen?",
        answer: "Ja, met één maand opzegtermijn."
      }
    ],
    relatedServices: [
      {
        id: "events",
        title: "Events",
        description: "Exclusieve car meets",
        price: "Vanaf €49",
        image: "https://images.unsplash.com/photo-1486262715619-67b85e0b08d3?q=80&w=2574&auto=format&fit=crop"
      },
      {
        id: "training",
        title: "Training",
        description: "Technical workshops",
        price: "Vanaf €199",
        image: "https://images.unsplash.com/photo-1486262715619-67b85e0b08d3?q=80&w=2574&auto=format&fit=crop"
      }
    ],
    guarantee: {
      duration: "1 jaar lidmaatschap",
      coverage: [
        "Events",
        "Platform",
        "Support",
        "Voordelen"
      ],
      terms: [
        "Volgens huisregels",
        "Bij actieve participatie",
        "Niet overdraagbaar"
      ]
    },
    qualityStandards: [
      {
        icon: "👥",
        name: "Community",
        description: "Actieve community"
      },
      {
        icon: "🎯",
        name: "Expertise",
        description: "Kennisdeling centraal"
      },
      {
        icon: "🤝",
        name: "Netwerk",
        description: "Waardevol netwerk"
      }
    ],
    maintenanceTips: [
      {
        title: "Participatie",
        description: "Blijf actief in de community",
        importance: "high",
        frequency: "Wekelijks"
      },
      {
        title: "Events",
        description: "Bezoek regelmatig events",
        importance: "medium",
        frequency: "Maandelijks"
      },
      {
        title: "Netwerk",
        description: "Onderhoud je contacten",
        importance: "low",
        frequency: "Continu"
      }
    ]
  },
  "ppf": {
    id: "ppf",
    title: "PPF",
    subtitle: "Paint Protection Film",
    description: "Bescherm uw waardevolle voertuig met onze premium Paint Protection Film oplossingen. Onzichtbare maar effectieve bescherming tegen steenslag, krassen en UV-straling.",
    image: "https://lozejxkhsvwkksgzhrfd.supabase.co/storage/v1/object/public/images//ppf.jpg",
    benefits: [
      "Onzichtbare bescherming die de originele lak volledig behoudt",
      "Bescherming tegen steenslag, krassen en andere schade",
      "UV-bestendig om vergeling en verkleuring te voorkomen",
      "Zelfhelende eigenschappen bij lichte krassen",
      "Verhoogt de restwaarde van uw voertuig aanzienlijk"
    ],
    process: [
      "Grondige reiniging en voorbereiding van het voertuig",
      "Digitaal inmeten en op maat snijden van de PPF",
      "Professionele installatie door gecertificeerde specialisten",
      "Zorgvuldige afwerking van alle randen en hoeken",
      "Kwaliteitscontrole en instructies voor onderhoud"
    ],
    specifications: [
      {
        name: "UV Blocking",
        value: "99%",
        description: "UV-bescherming"
      },
      {
        name: "Garantie",
        value: "10 jaar",
        description: "Langdurige garantie"
      },
      {
        name: "Installatie",
        value: "1-3 dagen",
        description: "Professionele service"
      },
      {
        name: "Zelfhelend",
        value: "Ja",
        description: "Herstelt van kleine krassen"
      }
    ],
    materials: [
      {
        name: "XPEL Ultimate Plus",
        brand: "XPEL",
        description: "Premium zelfhelende PPF film met 10 jaar garantie",
        image: "https://images.unsplash.com/photo-1507136566006-cfc505b114fc?q=80&w=2574&auto=format&fit=crop"
      },
      {
        name: "3M Scotchgard Pro",
        brand: "3M",
        description: "Hoogwaardige beschermfolie met uitstekende helderheid",
        image: "https://images.unsplash.com/photo-1507136566006-cfc505b114fc?q=80&w=2574&auto=format&fit=crop"
      }
    ],
    certifications: [
      {
        name: "XPEL Certified",
        issuer: "XPEL",
        validUntil: "2025-12-31",
        image: "https://images.unsplash.com/photo-1507136566006-cfc505b114fc?q=80&w=2574&auto=format&fit=crop"
      },
      {
        name: "3M Preferred Installer",
        issuer: "3M",
        validUntil: "2025-12-31",
        image: "https://images.unsplash.com/photo-1507136566006-cfc505b114fc?q=80&w=2574&auto=format&fit=crop"
      }
    ],
    statistics: {
      projectsCompleted: 1500,
      yearsExperience: 10,
      satisfactionRate: 99,
      clientsServed: 1200
    },
    packages: [
      {
        name: "Front Protection",
        price: "€1.499",
        description: "Bescherming voor de kwetsbare delen",
        features: [
          "Motorkap",
          "Voorbumper",
          "Koplampen",
          "Spiegels",
          "5 jaar garantie"
        ],
        buttonText: "Selecteer pakket"
      },
      {
        name: "Full Front Protection",
        price: "€2.499",
        description: "Complete voorzijde bescherming",
        features: [
          "Front Protection +",
          "Volledige voorspatborden",
          "A-stijlen",
          "7 jaar garantie"
        ],
        buttonText: "Selecteer pakket",
        isPopular: true
      },
      {
        name: "Full Vehicle Protection",
        price: "€4.999",
        description: "Volledige voertuigbescherming",
        features: [
          "Alle carrosseriedelen",
          "Bumpers en spiegels",
          "Koplampen",
          "10 jaar garantie"
        ],
        buttonText: "Selecteer pakket"
      }
    ],
    faq: [
      {
        category: "Duurzaamheid",
        question: "Hoe lang gaat een PPF folie mee?",
        answer: "Bij goede verzorging heeft onze PPF folie een levensduur van minstens 10 jaar zonder verkleuring of kwaliteitsverlies."
      },
      {
        category: "Onderhoud",
        question: "Heeft een auto met PPF speciaal onderhoud nodig?",
        answer: "Wassen kan gewoon met zachte autoshampoo. Vermijd agressieve chemicaliën en krachtige hogedrukreinigers op de naden."
      },
      {
        category: "Installatie",
        question: "Kan PPF later verwijderd worden?",
        answer: "Ja, een professioneel aangebrachte PPF folie kan verwijderd worden zonder schade aan de lak."
      },
      {
        category: "Garantie",
        question: "Wat dekt de garantie?",
        answer: "De garantie dekt vergeling, verkleuring, barsten, bladderen en loskomen bij normaal gebruik."
      }
    ],
    relatedServices: [
      {
        id: "detailing",
        title: "Detailing",
        description: "Professionele voorbereiding voor PPF",
        price: "Vanaf €299",
        image: "https://images.unsplash.com/photo-1507136566006-cfc505b114fc?q=80&w=2574&auto=format&fit=crop"
      },
      {
        id: "glascoating",
        title: "Glascoating",
        description: "Extra bescherming en glans",
        price: "Vanaf €699",
        image: "https://images.unsplash.com/photo-1507136566006-cfc505b114fc?q=80&w=2574&auto=format&fit=crop"
      }
    ],
    guarantee: {
      duration: "Tot 10 jaar garantie",
      coverage: [
        "Vergeling",
        "Verkleuring",
        "Barsten",
        "Loskomen"
      ],
      terms: [
        "Bij normaal gebruik",
        "Regelmatige controle",
        "Volgens onderhoudsvoorschriften"
      ]
    },
    qualityStandards: [
      {
        icon: "🛡️",
        name: "Premium Bescherming",
        description: "Hoogwaardige beschermlaag"
      },
      {
        icon: "✨",
        name: "Onzichtbare Folie",
        description: "Behoudt de originele look"
      },
      {
        icon: "👨‍🔧",
        name: "Vakkundige Installatie",
        description: "Door gecertificeerde specialisten"
      }
    ],
    maintenanceTips: [
      {
        title: "Regelmatig Wassen",
        description: "Was uw auto regelmatig met pH-neutrale autoshampoo",
        importance: "high",
        frequency: "Tweewekelijks"
      },
      {
        title: "Inspectie",
        description: "Laat de PPF jaarlijks inspecteren",
        importance: "medium",
        frequency: "Jaarlijks"
      },
      {
        title: "Vlekbehandeling",
        description: "Verwijder hardnekkige vervuiling direct",
        importance: "low",
        frequency: "Indien nodig"
      }
    ]
  },
  "uitlaatsysteem": {
    id: "uitlaatsysteem",
    type: "UITLAATSYSTEEM" as ExpertiseType,
    title: "UITLAATSYSTEEM",
    subtitle: "Performance Exhaust",
    description: "Premium uitlaatsystemen voor optimaal geluid en prestaties. Van subtiele verbeteringen tot complete performance systemen.",
    image: "https://images.unsplash.com/photo-1486262715619-67b85e0b08d3?q=80&w=2940&auto=format&fit=crop",
    benefits: [
      "Verbeterde prestaties en vermogen",
      "Uniek geluid dat past bij uw persoonlijkheid",
      "Gewichtsreductie ten opzichte van standaard uitlaat",
      "Superieure kwaliteit materialen",
      "Professionele installatie en afstelling"
    ],
    process: [
      "Geluidsconsultatie en persoonlijke wensen",
      "3D design en simulatie van het systeem",
      "Professionele verwijdering van het oude systeem",
      "Precisie installatie van het nieuwe systeem",
      "Test en finetuning voor optimaal resultaat"
    ],
    specifications: [
      {
        name: "Materiaal",
        value: "RVS 304/316",
        description: "Hoogwaardige roestvrijstalen constructie"
      },
      {
        name: "Gewichtsreductie",
        value: "30-50%",
        description: "Lichter dan standaard systemen"
      },
      {
        name: "Prestatieverbetering",
        value: "5-15%",
        description: "Afhankelijk van voertuig en systeem"
      },
      {
        name: "Garantie",
        value: "5 jaar",
        description: "Op materiaal en vakmanschap"
      }
    ],
    materials: [
      {
        name: "Akrapovič Evolution",
        brand: "Akrapovič",
        description: "Premium titanium en carbon fiber uitlaatsystemen met superieure prestaties",
        image: "https://images.unsplash.com/photo-1486262715619-67b85e0b08d3?q=80&w=2940&auto=format&fit=crop"
      },
      {
        name: "Milltek Sport",
        brand: "Milltek",
        description: "Hoogwaardige RVS systemen voor optimale prestaties en geluid",
        image: "https://images.unsplash.com/photo-1486262715619-67b85e0b08d3?q=80&w=2940&auto=format&fit=crop"
      },
      {
        name: "Supersprint",
        brand: "Supersprint",
        description: "Italiaanse precisie en kwaliteit voor motorsport prestaties",
        image: "https://images.unsplash.com/photo-1486262715619-67b85e0b08d3?q=80&w=2940&auto=format&fit=crop"
      }
    ],
    certifications: [
      {
        name: "TÜV Certified",
        issuer: "TÜV",
        validUntil: "2025-12-31",
        image: "https://images.unsplash.com/photo-1486262715619-67b85e0b08d3?q=80&w=2940&auto=format&fit=crop"
      },
      {
        name: "ABE Approved",
        issuer: "KBA",
        validUntil: "2025-12-31",
        image: "https://images.unsplash.com/photo-1486262715619-67b85e0b08d3?q=80&w=2940&auto=format&fit=crop"
      }
    ],
    statistics: {
      projectsCompleted: 800,
      yearsExperience: 8,
      satisfactionRate: 98,
      clientsServed: 650
    },
    packages: [
      {
        name: "Cat-Back System",
        price: "€1.299",
        description: "Achterdemper vervangen voor verbeterd geluid",
        features: [
          "RVS constructie",
          "Verbeterde flow",
          "Sportieve sound",
          "3 jaar garantie"
        ],
        buttonText: "Selecteer pakket"
      },
      {
        name: "Turbo-Back System",
        price: "€2.499",
        description: "Complete systeem vanaf turbo",
        features: [
          "Cat-Back + downpipe",
          "Maximum prestaties",
          "Race-proven design",
          "5 jaar garantie"
        ],
        buttonText: "Selecteer pakket",
        isPopular: true
      },
      {
        name: "Complete Racing System",
        price: "€3.999",
        description: "Full titanium racing systeem",
        features: [
          "Titanium constructie",
          "Carbon fiber tips",
          "Valvetronic technologie",
          "10 jaar garantie"
        ],
        buttonText: "Selecteer pakket"
      }
    ],
    faq: [
      {
        category: "Geluid",
        question: "Kan ik het geluidsniveau kiezen?",
        answer: "Ja, we hebben verschillende opties van subtiel tot race-ready. We bespreken uw wensen tijdens de consultatie."
      },
      {
        category: "Legaliteit",
        question: "Is een aangepast uitlaatsysteem legaal?",
        answer: "Alle onze systemen zijn TÜV-gecertificeerd en hebben een ABE-keurmerk voor weggebruik."
      },
      {
        category: "Prestaties",
        question: "Hoeveel extra vermogen krijg ik?",
        answer: "Afhankelijk van uw auto en systeem kunt u 5-15% extra vermogen verwachten."
      },
      {
        category: "Installatie",
        question: "Hoe lang duurt de installatie?",
        answer: "Een standaard cat-back systeem duurt 4-6 uur, complete systemen kunnen 1-2 dagen duren."
      }
    ],
    relatedServices: [
      {
        id: "chiptuning",
        title: "Chiptuning",
        description: "Optimale prestaties met aangepaste motorsturing",
        price: "Vanaf €699",
        image: "https://images.unsplash.com/photo-1486262715619-67b85e0b08d3?q=80&w=2940&auto=format&fit=crop"
      },
      {
        id: "modificaties",
        title: "Performance Modificaties",
        description: "Complete performance upgrades",
        price: "Vanaf €1.299",
        image: "https://images.unsplash.com/photo-1486262715619-67b85e0b08d3?q=80&w=2940&auto=format&fit=crop"
      }
    ],
    guarantee: {
      duration: "Tot 10 jaar garantie",
      coverage: [
        "Materiaaldefecten",
        "Lasnaden",
        "Roestvorming",
        "Installatie gebreken"
      ],
      terms: [
        "Bij normaal gebruik",
        "Jaarlijkse inspectie aanbevolen",
        "Gebruik van goedgekeurde additieven"
      ]
    },
    qualityStandards: [
      {
        icon: "🔧",
        name: "Precisie Fabricage",
        description: "Computergestuurde productie voor perfecte pasvorm"
      },
      {
        icon: "🎵",
        name: "Geluid Engineering",
        description: "Wetenschappelijk ontworpen voor optimaal geluid"
      },
      {
        icon: "🏁",
        name: "Racing Heritage",
        description: "Technologie rechtstreeks uit de motorsport"
      }
    ],
    maintenanceTips: [
      {
        title: "Regelmatige Inspectie",
        description: "Controleer bevestigingen en ophangpunten elke 6 maanden",
        importance: "high",
        frequency: "Halfjaarlijks"
      },
      {
        title: "Reiniging",
        description: "Reinig RVS onderdelen met speciale RVS cleaner",
        importance: "medium",
        frequency: "Maandelijks"
      },
      {
        title: "Geluidsniveau Check",
        description: "Laat geluidsniveau jaarlijks controleren",
        importance: "low",
        frequency: "Jaarlijks"
      }
    ]
  }
} 